export default {
  form: {
    address: {
      label: 'Indirizzo',
      placeholder: 'Via + numero',
    },
    city: {
      label: 'Città',
      placeholder: 'Città',
    },
    state: {
      label: 'Provincia',
      placeholder: 'Seleziona provincia',
    },
    country: {
      label: 'Paese',
      placeholder: 'Seleziona paese',
    },
    zip_code: {
      label: 'Codice postale',
      placeholder: 'Codice postale',
    },
  },
};
